import ServiceProvider from '@api-consent/model/ServiceProvider';
import StaticTable from '@api-consent/util/StaticTable';
import data from './spsRaw';

export default new StaticTable(data.map((item) => new ServiceProvider(item)), { pick: 'SP301' });
